import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IFormFieldSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IFormArrayTableProps } from '.';

export const generate = (
  props?: Partial<IFormFieldSchema<IFormArrayTableProps>>
): IFormFieldSchema<IFormArrayTableProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.ARRAY,
    name: props?.name || id,
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-decorator': 'FormItem',
    'x-component': ComponentType.FormArrayTable,
    'x-component-props': {
      title: props?.['x-component-props']?.title || 'Array Table',
      canEditRow: props?.['x-component-props']?.canEditRow ?? true,
      canDeleteRow: props?.['x-component-props']?.canDeleteRow ?? true,
      canDuplicateRow: props?.['x-component-props']?.canDuplicateRow ?? false,
      buttonText: props?.['x-component-props']?.buttonText || 'Add',
      buttonType: props?.['x-component-props']?.buttonType || 'primary',
      buttonSize: props?.['x-component-props']?.buttonSize || 'middle',
      buttonBlock: props?.['x-component-props']?.buttonBlock ?? false,
      buttonDanger: props?.['x-component-props']?.buttonDanger ?? false,
      buttonDisabled: props?.['x-component-props']?.buttonDisabled ?? false,
      buttonGhost: props?.['x-component-props']?.buttonGhost ?? false,
      buttonVisible: props?.['x-component-props']?.buttonVisible ?? true,
      rowItemName: props?.['x-component-props']?.rowItemName || 'row',
      childSchema: {
        type: JsonFieldType.VOID,
        name: 'childSchema',
        'x-component': ComponentType.ChildContainer,
        'x-component-props': {},
        'x-component-props-config': {},
        'x-designable-id': uuidv4(),
        'x-index': 0,
        properties: {
          childSchemaForm: {
            type: JsonFieldType.OBJECT,
            name: 'childSchemaForm',
            'x-component': ComponentType.Form,
            'x-component-props': {},
            'x-component-props-config': {},
            'x-designable-id': uuidv4(),
            'x-index': 0,
            properties: {},
          },
        },
      },
    },
    'x-component-props-config': {},
  };
};
